import React, { memo, Fragment } from 'react';
import { CommonActions, DrawerActions } from '@react-navigation/native';
import { DrawerSeparator } from '@redlink/components/atoms';
import { DrawerItem } from '@redlink/components/molecules';

export const DrawerItemList = memo(({ state, navigation, descriptors }) => {
  return state.routes.map((route, i) => {
    const focused = i === state.index;
    const {
      title,
      drawerLabel,
      drawerIcon,
      newSection,
      drawerActiveTintColor,
      drawerInactiveTintColor,
      itemStyle,
      labelStyle,
    } = descriptors[route.key].options;

    return (
      <Fragment key={route.key}>
        {newSection && <DrawerSeparator />}
        <DrawerItem
          label={
            drawerLabel !== undefined
              ? drawerLabel
              : title !== undefined
              ? title
              : route.name
          }
          icon={drawerIcon}
          focused={focused}
          activeTintColor={drawerActiveTintColor}
          inactiveTintColor={drawerInactiveTintColor}
          labelStyle={labelStyle}
          style={itemStyle}
          onPress={() => {
            navigation.dispatch({
              ...(focused
                ? DrawerActions.closeDrawer()
                : CommonActions.navigate(route.name)),
              target: state.key,
            });
          }}
        />
      </Fragment>
    );
  });
});
